import React from "react";
import { useContext } from "react";
import PsContext from "../../../context";
import { momentDate } from "../../../utils";
import { Col, Row } from "react-bootstrap";

const FooterBottom = (props) => {
  const context = useContext(PsContext);

  return (
    <section className="wed-rights">
      <div className="container">
        <div className="row">
          <div
            className="copy-right py-3 text-white"
            style={{ fontSize: "14px" }}
          >
            <Row>
              <Col md={8}>
                Copyrights &copy; {/*({momentDate(new Date(), "YYYY")}){" "}*/}
                {context.settingValue("web_site_name")}. All rights reserved.
              </Col>
              <Col className="text-end" md={4} style={{ fontSize: "13px" }}>
                Designed and Developed by{" "}
                <a
                  href="https://peacesoft.in"
                  style={{
                    color: `#c3b9b9`,
                    textDecoration: "underline",
                  }}
                  target="_blank"
                >
                  Peace Soft
                </a>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterBottom;
